import {createAction} from '@reduxjs/toolkit';

export const getTikTokAuthUrl = createAction<{
  onSuccess?: () => void;
  audioId?: string;
}>('getTikTokAuthUrl');

export const getTikTokAuthUrlSuccess = createAction<{
  authUrl: string;
}>('getTikTokAuthUrlSuccess');

export const getTikTokAuthUrlFailure = createAction<string>(
  'getTikTokAuthUrlFailure',
);

export const syncTikTokAccount = createAction<{
  code: string;
  onSuccess?: () => void;
}>('syncTikTokAccount');

export const syncTikTokAccountSuccess = createAction<any>(
  'syncTikTokAccountSuccess',
);

export const syncTikTokAccountFailure = createAction<string>(
  'syncTikTokAccountFailure',
);

export const uploadToTikTok = createAction<{
  audioId: string;
  onSuccess?: () => void;
  onError?: () => void;
}>('uploadToTikTok');

export const uploadToTikTokSuccess = createAction<any>('uploadToTikTokSuccess');

export const uploadToTikTokFailure = createAction<string>(
  'uploadToTikTokFailure',
);
